import { setMenuSymbol, setSymbolActive } from '../redux/reducer/instruments';
import { setDropdown } from '../redux/reducer/dropdown';
import { getMenuFromLocalstorage } from '../utilities/fromStorage';
import { SymbolInfoSchema } from '../types/symbol';
import { useAppDispatch } from '../redux/app';

/**
 * Custom hook for changing symbols
 * @returns {Function} Function to change the active symbol
 */
const useChangeSymbol = (dispatch) => {
  const changeSymbol = (symbolData) => {
    // const symbolProps = SymbolInfoSchema.parse(symbolData);
    console.log('symbolProps', symbolData)
    const { symbol } = symbolData;
    
    // Get fresh data from localStorage when function is called
    const { menu, accountId } = getMenuFromLocalstorage();

    // Check if symbol already exists in menu
    if (menu?.find((item) => item.symbol === symbol)) {
      // Symbol exists, just activate it
      dispatch(setSymbolActive(symbol));
      dispatch(setDropdown(false));
    } else {
      // Symbol doesn't exist, add it to menu first
      setTimeout(() => {
        dispatch(setSymbolActive(symbol));
        dispatch(setMenuSymbol({ type: 'new', symbol: symbol, active: accountId }));
        dispatch(setDropdown(false));
      }, 500);
    }
  };

  return changeSymbol;
};

export default useChangeSymbol;
